<div class="mat-elevation-z0">
  <div class="top-table">
    <h4 class="table-header">{{variables.lastEstimates}}</h4>
    <div class="filters">
      <p class="ps" style="margin: auto; display: flex; justify-content: center;">
        <span style="margin: auto;">{{variables.filters}} &nbsp; </span>
        @if (!showFiltersValue) {
        <mat-icon (click)="showFilters()">keyboard_arrow_down
        </mat-icon>
        }
        @if (showFiltersValue) {
        <mat-icon (click)="showFilters()">
          keyboard_arrow_up
        </mat-icon>
        }
      </p>
    </div>
  </div>
  @if (showFiltersValue) {
  <mat-divider class="filters-divider"> </mat-divider>
  <div @slideToggle class="container">
    <div class="filter-group search-filter-group">
      <label style="margin-bottom: 0.5rem; font-weight: 600; font-size: 0.928em;">Filter</label>
      <mat-form-field class="estimate-search-field" appearance="outline">
        <input class="searchInput" matInput placeholder="{{variables.search}}..." search [(ngModel)]="searchInput"
          (keyup)="onSearchChange($event)" />
      </mat-form-field>
    </div>
    <div class="filter-group state-filter-group">
      <h6 style="text-align: center;">{{variables.filterState}}</h6>
      <div class="container_row">
        <div class="state-filter">
          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.INCOMPLETE) }"
            (click)="toggleState(estimationState.INCOMPLETE)">{{variables.onGoing}}</div>

          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.COMPLETE) }"
            (click)="toggleState(estimationState.COMPLETE)">
            {{variables.finished}}</div>

          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.CERTIFIED) }"
            (click)="toggleState(estimationState.CERTIFIED)">
            {{variables.certified}}</div>


          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.APPROVED) }"
            (click)="toggleState(estimationState.APPROVED)">
            {{variables.approved}}</div>

          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.REJECTED) }"
            (click)="toggleState(estimationState.REJECTED)">
            {{variables.rejected}}</div>

          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.TO_FIX) }"
            (click)="toggleState(estimationState.TO_FIX)">
            {{variables.toFix}}</div>

          <div class="state" [ngClass]="{ 'selected': isStateSelected(estimationState.CLOSED) }"
            (click)="toggleState(estimationState.CLOSED)">
            {{variables.Closed}}</div>

        </div>
      </div>
    </div>
    <div class="filter-group slider-container">
      <div class="dataRange">
        <h6>{{variables.filterTime}}</h6>
        <mat-slider min="0" max="4" step="1" [discrete]="true" [showTickMarks]="true">
          <input matSliderThumb [(ngModel)]="sliderValue" (ngModelChange)="updateLabel($event)">
        </mat-slider>
        <div class="labels">
          <label>{{variables.month1}}</label>
          <label>{{variables.month3}}</label>
          <label>{{variables.month6}}</label>
          <label>{{variables.year1}}</label>
          <label>{{variables.allyears}}</label>
        </div>
      </div>
    </div>
  </div>
  }

  <mat-divider> </mat-divider>
  <div class="table-container horizontal-center">
    <table mat-table class="full-width-table " matSort [dataSource]="dataSource" (matSortChange)="sortData($event)">

      <!-- ID Column -->
      <ng-container matColumnDef="ID">
        <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef>Id</th>
        <td mat-cell style="flex-basis: 15%;" class="vertical-center" *matCellDef="let row">{{row.idEstimate}}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="estimativa">
        <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef mat-sort-header>{{variables.estimation}}</th>
        <td mat-cell style="flex-basis: 15%;" class="td-name vertical-center" *matCellDef="let row">
          <div>{{row.name}}</div>
        </td>
      </ng-container>

      <!-- Tecnologia Column -->
      <ng-container matColumnDef="tecnologia">
        <th mat-header-cell style="flex-basis: 12%;" *matHeaderCellDef mat-sort-header>{{variables.catalog}}</th>
        <td mat-cell style="flex-basis: 12%;" class="td-name vertical-center" *matCellDef="let row">
          <div>{{row.catalog}}</div>
        </td>
      </ng-container>

      <!-- Data I Column -->
      <ng-container matColumnDef="data_i">
        <th mat-header-cell style="flex-basis: 11%;" *matHeaderCellDef mat-sort-header>{{variables.creationDate}}</th>
        <td mat-cell style="flex-basis: 11%;" class="vertical-center" *matCellDef="let row">{{row.createdDate}}</td>
      </ng-container>

      <!-- Data F Column -->
      <ng-container matColumnDef="data_f">
        <th mat-header-cell style="flex-basis: 11%;" *matHeaderCellDef mat-sort-header>{{variables.changeDate}}</th>
        <td mat-cell style="flex-basis: 11%;" class="vertical-center" *matCellDef="let row">{{row.lastModifiedDate}}
        </td>
      </ng-container>

      <!-- State Column -->
      <ng-container class="table-state" matColumnDef="state">
        <th mat-header-cell style="flex-basis: 11%;" *matHeaderCellDef mat-sort-header>{{variables.state}}</th>
        <td mat-cell style="flex-basis: 11%;" class="vertical-center" *matCellDef="let row">
          <span class="state-background" [ngClass]="{
            'green-class': row.state === estimationState.CERTIFIED || row.state === estimationState.APPROVED,
            'yellow-class': row.state === estimationState.INCOMPLETE ,
            'red-class': row.state === estimationState.TO_FIX ,
            'dark-green-class': row.state === estimationState.CLOSED,
            'dark-red-class': row.state === estimationState.REJECTED,
            'blue-class': row.state === estimationState.COMPLETE
          }">
            {{ getStateText(row.state) }}
          </span>
        </td>
      </ng-container>

      <!-- Project Column -->
      <ng-container matColumnDef="project">
        <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef mat-sort-header>{{variables.project}}</th>
        <td mat-cell style="flex-basis: 15%;" class="vertical-center" *matCellDef="let row">{{row.project}}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell style="flex-basis: 10%;" class="vertical-center horizontal-center" *matHeaderCellDef
          mat-sort-header>{{variables.actions}}</th>
        <td mat-cell style="flex-basis: 10%;" class="vertical-center horizontal-center-btn" *matCellDef="let row">

          <span *hasPermission="Permission.ESTIMATE_WRITE" (click)="editEstimate(row)" class="action_buttons-item"
            [matTooltip]="canEditEstimateMessage(row)" [class.disabled]="!canEditEstimate(row)">
            <mat-icon width="20px">edit</mat-icon>
          </span>

          <span (click)="checkEstimate(row)" class="action_buttons-item" [matTooltip]="canCheckEstimateMessage(row)"
            [class.disabled]="!canCheckEstimate(row)">
            <mat-icon width="20px">remove_red_eye</mat-icon>
          </span>

          <span *hasPermission="Permission.ESTIMATE_WRITE" (click)="deleteEstimate(row)" class="action_buttons-item"
            [matTooltip]="canDeleteEstimateMessage(row)" [class.disabled]="!canDeleteEstimate(row)">
            <mat-icon width="20px">delete</mat-icon>
          </span>


        </td>
      </ng-container>



      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; let i = index; columns: displayedColumns;" [hidden]="isLoading"></mat-row>

    </table>
  </div>
  <!-- Loader & Error Messages Outside the Table -->
  @if (isLoading && !errorDetected) {
  <app-loader class="centerLoader"></app-loader>
  }
  @if (errorDetected) {
  <app-error-message [errorMsg]="errorText"></app-error-message>
  }


  <mat-paginator #paginator [length]="paginatorTotalElements" [pageIndex]="paginatorCurrentIndex"
    [pageSize]="paginatorPageSize" [hidePageSize]="true" (page)="onPageChange($event)" aria-label="Select page">
  </mat-paginator>
</div>